import { render, staticRenderFns } from "./CertificateManagementView.vue?vue&type=template&id=48ffed5f&scoped=true&"
import script from "./CertificateManagementView.vue?vue&type=script&lang=js&"
export * from "./CertificateManagementView.vue?vue&type=script&lang=js&"
import style0 from "./CertificateManagementView.vue?vue&type=style&index=0&id=48ffed5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ffed5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
